import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedEvents from './components/FeaturedEvents';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import AdvantagesSection from './components/AdvantagesSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="开元体育 - 官方平台·专业体育娱乐体验"
        description="开元体育是您首选的专业体育娱乐平台，汇聚多元体育赛事、实时赔率与顶级竞技内容。开元体育为用户提供安全、公平、流畅的在线体育体验，立即注册享受专属福利与一流服务。"
        keywords="开元体育,开元体育官网,开元体育平台,开元体育注册,开元体育登录,开元体育赛事,开元体育优惠活动"
        canonicalUrl="https://www.kaiyuansports.com/"
        ogTitle="开元体育 - 官方平台·专业体育娱乐体验"
        ogDescription="开元体育是您首选的专业体育娱乐平台，汇聚多元体育赛事、实时赔率与顶级竞技内容。安全、公平、流畅的在线体育体验。"
      />
      <HeroSection />
      <FeaturedEvents />
      <CategorySection />
      <LatestArticles />
      <AdvantagesSection />
      <CTASection />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '开元体育',
            url: 'https://www.kaiyuansports.com',
            description: '开元体育是专业体育娱乐平台，提供多元体育赛事、实时赔率与顶级竞技内容',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.kaiyuansports.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '开元体育 - 官方平台',
            description: '开元体育官方平台首页，专业体育娱乐体验',
            isPartOf: {
              '@type': 'WebSite',
              name: '开元体育',
              url: 'https://www.kaiyuansports.com',
            },
          }),
        }}
      />
    </>
  );
}